
import { TranslateService } from "@ngstack/translate";
import { FormGroup } from "@angular/forms";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatTableDataSource, MatDialog } from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICompany } from "src/app/interfaces/company";
import { PackageEducationBranchService } from "src/app/services/http/business/packageEducationBranch/package-education-branch.service";
import { ActivatedRoute } from "@angular/router";
import { AddLevelToPackageComponent } from "../add-level-to-package/add-level-to-package.component";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";

@Component({
  selector: "package-education-branch.component",
  templateUrl: "./package-education-branch.component.html",
  styleUrls: ["./package-education-branch.component.css"]
})
export class PackageEducationBranchComponent implements OnInit {
  form: FormGroup;
  branchList: IBranch[];
  companyList: ICompany[];
  packageId: number;
  isOwner: boolean;
  BranchEncryptId: string;
  companySelected: string;
  dataSource = new MatTableDataSource();
  package: IEducationPackage;
  activeBranchList: any[];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [
    this.translate.get("label.branch"),
    this.translate.get("label.status"),
    "function"
  ];


  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private packageEducationBranchService: PackageEducationBranchService,
    private educationPackageService: EducationPackageService,
  ) { }

  ngOnInit() {
    this.setPackageId();
    this.loadTable();
    this.checkOwner();
  }

  setPackageId() {
    this.route.params.subscribe(res => {
      this.packageId = res.packageId;
      this.educationPackageService.getById(res.packageId).subscribe(res => {
        this.package = res;

      })
    });
  }

  assignLevelToBranches() {
    this.dialog
      .open(AddLevelToPackageComponent, {
        width:"350px",
        disableClose:true,
        data: {
          packageId: this.packageId,
          branchEncryptList: this.activeBranchList.map(e => e.BranchEncryptId)
        }
      })
      .afterClosed()
      .subscribe(() => {
        this.loadTable();
        console.log("success");

      }, () => {
        console.log('error');

      })
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  loadTable() {
    this.dataSource = null;
    this.packageEducationBranchService.getBranches(this.packageId).subscribe(res => {
      this.activeBranchList = res;
      this.dataSource = res;
    });
  }

  ative(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.educationPackage") + " " + this.package.PackageName + " " + this.translate.get("label.in") + " " + data.BranchName
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.educationPackage") + " " + this.package.PackageName + " " + this.translate.get("label.in") + " " + data.BranchName
        }),
        alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "400px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
     
      let model = {
        IsActive: !data.IsActive,
        //EducationPackageName:"",
        EducationPackageId: this.packageId,
        BranchEncryptList: [
          data.BranchEncryptId
        ]
      }
      if (result) {
        this.packageEducationBranchService.activeDeactiveEducationPackageinBranch(model).subscribe(
          () => {
          
            this.loadTable();
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }


  getColor(e) {
    switch (e.IsActive) {
      case true:
        return "custom-chips primary";
      case false:
        return "custom-chips accent";
    }
  }

  // add() {
  //   this.dialog
  //     .open(AddLevelToPackageComponent, {
  //       data: this.packageId
  //     })
  //     .afterClosed()
  //     .subscribe(() => {
  //       this.loadTable();
  //       console.log("success");

  //     }, () => {
  //       console.log('error');

  //     })
  // }
}
